import { datadogRum } from "@datadog/browser-rum";
import { ENV } from "../api-routes";
import { datadogLogs } from "@datadog/browser-logs";
import Config from "../config/env";

const dataDogRumConfig = {
  applicationId: Config.DATADOG_APP_ID,
  clientToken: Config.DATADOG_CLIENT_TOKEN,
  site: "datadoghq.com",
  service: "gateway-gxm",
  env: ENV,
  version: "0.0.1",
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  defaultPrivacyLevel: "mask-user-input",
};

export const initRum = () => {
  if (ENV !== "PROD") {
    console.info("Datadog RUM is disabled in non-PROD environments");
    return;
  }
  try {
    datadogRum.init(dataDogRumConfig);
    console.info("Datadog RUM initialized successfully 🐶");
  } catch (error) {
    console.error("Failed to initialize Datadog RUM:", error);
    datadogLogs.logger.error("Datadog RUM initialization error", { error });
  }
};
